import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import CdSelectAddressModal from "./CdSelectAddressModal"
import classes from "./index.module.scss"

const CheckoutDelivery = props => {
  const { isGuestOrder, selectedUserAccount } = props

  const [t] = useTranslation()

  const [openMapAddressModal, setOpenMapAddressModal] = useState(false)

  const deliveryAddress =
    useSelector(state =>
      state.deliveryInfo.deliveryAddress
    )

  const handleOpenMapAddress = () => {
    if (isGuestOrder) {
      return setOpenMapAddressModal(true)
    }

    if (!selectedUserAccount) {
      return toast.error(t("ابتدا_کاربر_خود_را_انتخاب_کنید"))
    }

    setOpenMapAddressModal(true)
  }

  return (
    <Fragment>
      <div
        onClick={handleOpenMapAddress}
        className={classes["container"]}
      >
        {!!deliveryAddress?.address
          ? deliveryAddress.address
          : t("آدرس_ارسال_را_اضافه_کنین")
        }
      </div>

      <CdSelectAddressModal
        isGuestOrder={isGuestOrder}
        guestDeliveryAddress={deliveryAddress}
        selectedUserAccount={selectedUserAccount}
        openMapAddressModal={openMapAddressModal}
        setOpenMapAddressModal={setOpenMapAddressModal}
      />
    </Fragment>
  )
}

export default CheckoutDelivery